export default "__VITE_ASSET__cb52751e__"